export default {
    setSelectedBlurringProject(state, project) {
        state.selectedBlurringProject = project
    },
    setSelectedBlurringDevice(state, device) {
        state.selectedBlurringDevice = device
    },
    setQueryData(state, queryData) {
        state.searchQueryData = queryData
    }
}
